const Foot = () =>{
    return(
        <>
            <div className="foot">                
                <div className="text-center">
                    <p className="text"><p>© Copyright <b>Aman Verma</b>. All Rights Reserved</p></p>
                    <p className="text">Designed with ♥ by Aman Verma</p>
                </div>
            </div>
        </>
    )

}
export default Foot